import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../const";

export default class SettingsAutomationsLogs extends SettingsModule {

    constructor() {
        super({
            name                     : "Automations Logs",
            description              : "",
            svgIcon                  : "isvg-logs",
            typeLabel                : "Organization account",
            settingsUrl              : "settings/automation-logs",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });

        this.parentSection          = SettingsParentSection.SYSTEM

        this.canDisable             = false
        this.hasStatus              = false
    }

}
